import React from 'react';
import AdminKbd from './AdminKbd';
import './AdminSearchInput.css';

const SearchGlyph = () => (
  <svg viewBox="0 0 16 16" aria-hidden="true">
    <circle cx="7" cy="7" r="4.25" fill="none" />
    <path d="M10.25 10.25L13.5 13.5" fill="none" />
  </svg>
);

/**
 * @param {{
 *   placeholder?: string,
 *   value?: string,
 *   onChange?: ((event: React.ChangeEvent<HTMLInputElement>) => void) | null,
 *   size?: 'sm' | 'md',
 *   leadingIcon?: React.ReactNode,
 *   kbdHint?: React.ReactNode,
 *   className?: string
 * } & React.InputHTMLAttributes<HTMLInputElement>} props
 */
const AdminSearchInput = React.forwardRef(function AdminSearchInput(
  {
    placeholder = 'Search…',
    value = '',
    onChange = null,
    size = 'md',
    leadingIcon = null,
    kbdHint = null,
    className = '',
    ...rest
  },
  ref,
) {
  return (
    <label className={`au-search-input au-scope au-search-input--${size}${className ? ` ${className}` : ''}`}>
      <span className="au-search-input__icon" aria-hidden="true">
        {leadingIcon || <SearchGlyph />}
      </span>
      <input
        ref={ref}
        type="search"
        className="au-search-input__field"
        data-admin-search-input="true"
        placeholder={placeholder}
        value={value}
        onChange={onChange || undefined}
        {...rest}
      />
      {kbdHint ? (
        <span className="au-search-input__hint">
          <AdminKbd>{kbdHint}</AdminKbd>
        </span>
      ) : null}
    </label>
  );
});

export default AdminSearchInput;
